(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.querySelector('tb-aisle-navigation [data-top-menu][open]')) { this.currentScrollTop = scrollTop; return; }

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tb-delivery-bar"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tb-delivery-strip')) {
  customElements.define('tb-delivery-strip', class extends HTMLElement {
    connectedCallback() {
      this.resizeObserver = new ResizeObserver(() => {
        document.documentElement.style.setProperty('--tb-delivery-height', this.offsetHeight + 'px');
      });
      this.resizeObserver.observe(this);
    }
    disconnectedCallback() {
      this.resizeObserver.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tb-google-reviews"] && !Shopify.designMode) return;
  try {
    
function tbInitGoogleReviews() {
  document.querySelectorAll('.tb-google-reviews__expand').forEach(button => {
    const text = document.getElementById(button.getAttribute('aria-controls'));
    if (!text) return;
    if (button.dataset.ready !== 'true') {
      button.dataset.ready = 'true';
      button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(expanded));
        text.classList.toggle('is-collapsed', !expanded);
        button.textContent = expanded ? button.dataset.less : button.dataset.more;
      });
    }
    if (button.getAttribute('aria-expanded') === 'true') return;
    text.classList.add('is-collapsed');
    const overflowing = text.scrollHeight > text.clientHeight + 2;
    button.hidden = !overflowing;
    if (!overflowing) text.classList.remove('is-collapsed');
  });
}
tbInitGoogleReviews();
document.addEventListener('shopify:section:load', tbInitGoogleReviews);
window.addEventListener('resize', tbInitGoogleReviews);
if (document.fonts) document.fonts.ready.then(tbInitGoogleReviews);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tb-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tb-hero-slideshow')) {
  customElements.define('tb-hero-slideshow', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('.tb-hero__slide')];
      if (this.slides.length < 2) return;
      this.dots = [...this.querySelectorAll('[data-hero-slide]')];
      this.current = 0;
      const show = (index) => {
        this.current = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === this.current);
          slide.setAttribute('aria-hidden', String(i !== this.current));
        });
        this.dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === this.current);
          if (i === this.current) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      };
      this.querySelector('[data-hero-prev]')?.addEventListener('click', () => show(this.current - 1));
      this.querySelector('[data-hero-next]')?.addEventListener('click', () => show(this.current + 1));
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => show(index)));
      if (this.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.timer = setInterval(() => show(this.current + 1), Number(this.dataset.interval) || 6000);
      }
    }
    disconnectedCallback() { clearInterval(this.timer); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tb-wholesale"]) return;
  try {
    
  function initialiseTradeLicenceForms() {
    document.querySelectorAll('[data-trade-licence]').forEach((block) => {
      if (block.dataset.initialised) return;
      block.dataset.initialised = 'true';
      const choice = block.querySelector('[data-licence-choice]');
      const fields = block.querySelector('[data-licence-fields]');
      const sync = () => {
        const alcohol = choice.value.startsWith('Yes');
        fields.hidden = !alcohol;
        fields.querySelectorAll('input, select').forEach((field) => {
          field.disabled = !alcohol;
          field.required = alcohol && field.hasAttribute('data-licence-required');
        });
      };
      choice.addEventListener('change', sync);
      sync();
    });
  }
  initialiseTradeLicenceForms();
  document.addEventListener('DOMContentLoaded', initialiseTradeLicenceForms);
  document.addEventListener('shopify:section:load', initialiseTradeLicenceForms);

  } catch(e) { console.error(e); }
})();
})();
